import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../../data/mock';

export const ServicesOverview = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="relative py-24 lg:py-32">
      <div className="absolute inset-0 bg-[var(--bg-soft)]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <span className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-3 block">
            What We Do
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-['Syne'] text-[var(--text-primary)] mb-5">
            Our Services
          </h2>
          <p className="text-[var(--text-muted)] text-lg max-w-2xl">
            End-to-end digital solutions designed to elevate your brand and accelerate your business growth.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 40 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.15 }}
              >
                <Link
                  to="/services"
                  className="group block h-full p-8 rounded-2xl bg-[var(--card-color)] border border-[var(--border-color)] hover:border-blue-500/30 transition-all duration-500 hover:shadow-lg hover:shadow-blue-500/5"
                >
                  <div className="w-12 h-12 rounded-xl bg-blue-600/10 border border-blue-500/20 flex items-center justify-center mb-6 group-hover:bg-blue-600/20 transition-colors duration-500">
                    <Icon className="w-6 h-6 text-blue-400" />
                  </div>

                  <h3 className="text-xl font-bold font-['Syne'] text-[var(--text-primary)] mb-3">
                    {service.title}
                  </h3>

                  <p className="text-[var(--text-muted)] text-sm leading-relaxed mb-6">
                    {service.shortDesc}
                  </p>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {service.features.slice(0, 3).map((feature) => (
                      <span
                        key={feature}
                        className="text-xs px-3 py-1 rounded-full bg-[var(--surface-2)] text-[var(--text-muted)] border border-[var(--border-color)]"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>

                  <span className="inline-flex items-center text-sm font-medium text-blue-400 group-hover:text-blue-300 transition-colors duration-300">
                    Learn More
                    <ArrowRight className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};